import script from "./VehicleSelectModel.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleSelectModel.vue?vue&type=script&setup=true&lang=js"

import "./VehicleSelectModel.vue?vue&type=style&index=0&id=74690abc&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74690abc"]])

export default __exports__